import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { TextLabelPlacementEnum } from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import HotelPurchaseAddOnsTable from './add-ons-table';
import HotelPurchaseGuestTable from './guest-table';
import HotelPurchaseHotelTable from './hotel-table';
import { ScheduleCardHeader } from '../../../style';

export default function HotelPurchaseHotelSection() {
  const { t } = useTranslation();
  return (
    <HOCInput keys={['approvalable.hotelPurchases']}>
      {(value) =>
        (value['approvalable.hotelPurchases'] || []).map((field, idx) => {
          const name = `approvalable.hotelPurchases.${idx}`;
          return (
            <React.Fragment key={field.id}>
              <CardSection>
                <ScheduleCardHeader $style={style}>
                  <Text variant="HeadingXSmall">
                    {t('ticketOrders:schedule_extra', {
                      extra: idx + 1,
                    })}
                  </Text>
                  <Input
                    type="text"
                    name={`${name}.bookingCode`}
                    label={t('common:booking_code')}
                    labelPlacement={TextLabelPlacementEnum.Left}
                    placeholder={t('common:booking_code')}
                    noMargin
                  />
                </ScheduleCardHeader>
                <Separator gap={24} />
                <SectionContainer>
                  <HalfContainer>
                    <Input
                      type="text"
                      name={`${name}.hotelName`}
                      label={t('common:hotel')}
                    />
                  </HalfContainer>
                </SectionContainer>
                <SectionContainer>
                  <HalfContainer>
                    <FullContainer style={styles.hotelIndentityContainer}>
                      <FullContainer>
                        <Input
                          type="text"
                          name={`${name}.hotelPhone`}
                          label={t('common:phone_number')}
                        />
                      </FullContainer>
                      <Separator gap={16} />
                      <FullContainer>
                        <Input
                          type="email"
                          name={`${name}.hotelEmail`}
                          label={t('common:email')}
                        />
                      </FullContainer>
                    </FullContainer>
                  </HalfContainer>
                  <HalfContainer>
                    <Input
                      type="text"
                      name={`${name}.hotelAddress`}
                      label={t('common:address')}
                    />
                  </HalfContainer>
                </SectionContainer>
                <SectionContainer>
                  <HalfContainer>
                    <FullContainer
                      $style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FullContainer>
                        <Input
                          type="text"
                          name={`${name}.defaultCheckInOut.in`}
                          label={t('common:check_in')}
                          disabled
                        />
                      </FullContainer>
                      <Separator gap={16} />
                      <FullContainer>
                        <Input
                          type="text"
                          name={`${name}.defaultCheckInOut.out`}
                          label={t('common:check_out')}
                          disabled
                        />
                      </FullContainer>
                    </FullContainer>
                  </HalfContainer>
                  <HalfContainer>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      <Input type="switch" name={`${name}.isByPax`} noMargin />
                      <Text variant="LabelMedium">
                        {t('common:pricing_by_per_pax')}
                      </Text>
                    </div>
                  </HalfContainer>
                </SectionContainer>
                <HotelPurchaseGuestTable parentIndex={idx} />
                <Separator gap={24} />
                <HotelPurchaseHotelTable parentIndex={idx} />
                <HotelPurchaseAddOnsTable parentIndex={idx} />
                <Separator gap={12} />
                <SectionContainer>
                  <HalfContainer>
                    <Input
                      type="check-box"
                      name={`${name}.isCityTax`}
                      label={t('common:city_tax')}
                      noMargin
                    />
                    <Input
                      type="text"
                      name={`${name}.cityTax`}
                      placeholder={t('common:city_tax')}
                      hideRequiredStar
                    />
                  </HalfContainer>
                </SectionContainer>
              </CardSection>
              <Separator gap={24} />
            </React.Fragment>
          );
        })
      }
    </HOCInput>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

const styles: { [key: string]: React.CSSProperties } = {
  hotelIndentityContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
